import jwtDecode from 'jwt-decode'

export const isValidJwtToken = (token: string) => {
  try {
    jwtDecode(token.trim())
    return true
  } catch (error) {
    return false
  }
}

export const getEmailFromJwt = (token: string) => {
  if (isValidJwtToken(token)) {
    const decoded = jwtDecode<{ email: string }>(token)
    return decoded?.email
  }

  return null
}
